<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- {{allot_leaves_list}} -->
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Allot Leaves </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete rounded outlined dense v-model="editedItem.leaveAcademicYear"
            :items="leave_academic_year_list" :rules="[(v) => !!v || 'required']" item-text="ay" item-value="id"
            label="Academic Year" single-line></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-autocomplete rounded outlined dense v-model="editedItem.leaveType" :items="leave_type_list"
            :rules="[(v) => !!v || 'required']" item-text="type" item-value="id" label="Leave Type"
            :filled="editedIndex == -1 ? false : true" single-line @change="putnull()"></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-autocomplete rounded outlined dense v-model="serviceType" :items="service_type_list"
             item-text="name" item-value="id" label="Employee Category"
            :filled="editedIndex == -1 ? false : true" return-object single-line clearable></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-autocomplete rounded outlined dense v-model="editedItem.employeeType" :items="employee_type_list"
            :rules="[(v) => !!v || 'required']" item-text="name" item-value="id" label="Employee Type"
            :filled="editedIndex == -1 ? false : true" return-object single-line @change="
              getEmployeeList(editedItem);
            getDataFromLeaveMaster();
            "></v-autocomplete>
        </v-col>
      
      </v-row>
      <v-row justify="center">
          <v-col cols="12" sm="6" md="3">
          <v-autocomplete multiple rounded outlined dense v-model="editedItem.employee" :items="employee_list"
            item-text="name" item-value="id" label="Employee" :filled="editedIndex == -1 ? false : true"
            single-line>
              <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.name }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text text-caption">
                    (+{{ editedItem.employee.length - 1 }} others)
                  </span>
                </template>
                <template v-slot:prepend-item>
                  <v-list-item @mousedown.prevent>
                    <v-list-item-action>
                      <v-checkbox
                        v-model="selected_all_teacher"
                        @change="toggle_teacher()"
                      >
                        <template #label
                          ><span class="ml-8">Select All</span>
                        </template>
                      </v-checkbox>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="12" sm="6" md="4">
          <b>From Date</b>
          <input id="datePickerId" readonly label="From Date" type="date" v-model="editedItem.from" disabled
            hint="Readonly" />

          <!-- <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="editedItem.from"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                rounded
                outlined
                dense
                v-model="editedItem.from"
                label="From Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </template>
            <v-date-picker v-model="editedItem.from" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(editedItem.from)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-menu> -->
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <b>To Date</b>
          <input id="datePickerId" readonly label="To Date" type="date" v-model="editedItem.to" disabled
            hint="Readonly" />
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <br />
          <v-text-field v-model="editedItem.numberOfDays" persistent-hint :hint="
              editedIndex == -1
                ? 'For example :: 1,2,3'
                : 'For example :: 1,2,3'
            " label="Number Of Leaves" :rules="[(v) => !!v || 'required']" type="number" rounded outlined dense>
          </v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center">
        <!-- <v-col cols="4">
          <input
            id="datePickerId"
            readonly
            label="To Date"
            type="date"
            v-model="editedItem.to"
          />
        </v-col> -->
        <v-col cols="12" sm="2" md="4"></v-col>
        <!-- <center> -->
        <v-col cols="12" md="6" sm="6">
          <v-btn class="button" @click="save">Save</v-btn>
          <!--:disabled="!valid"-->
        </v-col>
        <!-- </center> -->
      </v-row>
    </v-card>

    <v-data-table :headers="headers" :items="bookList1" class="elevation-1 box mytable" :search="search">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-col cols="12" md="6" sm="6">
            <!-- export btn code -->

            <!-- <v-btn color="success" dark class="exportbtn" outlined rounded>
              <download-excel
                class="mar"
                :data="allot_leaves_list"
                :fields="table_fields"
                worksheet="AllotLeaves"
                name="AllotLeaves.xls"
              >
                <v-icon dark>mdi-file-excel</v-icon> Export
              </download-excel>
            </v-btn> -->

            <!-- export btn code end-->
          </v-col>
          <v-col cols="12" md="6" sm="6" align="right">
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
          </v-col>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="500px">
            <!--
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Add Allot Leaves</v-btn>
          </template>
        -->
            <v-card>
              <v-form v-model="valid">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row dense>
                      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.leaveAcademicYear" persistent-hint label="Academic year"
                          readonly disabled rounded outlined dense>
                        </v-text-field>
                      </v-col>

                      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.leaveType" persistent-hint label="Leave Type" readonly
                          disabled rounded outlined dense>
                        </v-text-field>
                      </v-col>

                      <v-col v-if="editedIndex != -1" cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.employee" persistent-hint label="Employee" readonly disabled
                          rounded outlined dense>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.numberOfDays" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: 1,2,3'
                              : 'For example :: 1,2,3'
                          " label="Number Of Leaves" :rules="[(v) => !!v || 'required']" type="number" rounded outlined
                          dense>
                        </v-text-field>
                      </v-col>


                      <v-col cols="12" sm="12" md="12">
                        <b>From Date</b>
                        <input id="datePickerId" type="date" v-model="editedItem.from" readonly />
                        <!-- <v-menu
                          ref="emenu"
                          v-model="emenu"
                          :close-on-content-click="false"
                          :return-value.sync="editedItem.from"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              rounded
                              outlined
                              dense
                              v-model="editedItem.from"
                              label="From Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :rules="[(v) => !!v || 'required']"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.from"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="emenu = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.emenu.save(editedItem.from)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-menu> -->
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <b>To Date</b>

                        <input id="datePickerId" type="date" v-model="editedItem.to" readonly />
                        <!-- <v-menu
                          ref="emenu1"
                          v-model="emenu1"
                          :close-on-content-click="false"
                          :return-value.sync="editedItem.to"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              rounded
                              outlined
                              dense
                              v-model="editedItem.to"
                              label="To Date"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :rules="[(v) => !!v || 'required']"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            :min="editedItem.from"
                            v-model="editedItem.to"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="emenu1 = false"
                              >Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.emenu1.save(editedItem.to)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu> -->
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                  <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-toolbar>

        <v-row dense justify="center" align="center">
          <v-col cols="12" sm="3" md="auto" v-for="header in headers" :key="header.text" >
            <v-autocomplete v-if="filters.hasOwnProperty(header.value)" class="mr-2 pb-5 pt-2" flat hide-details small
              rounded dense outlined color="#0F2027" :label="header.text" multiple clearable
              :items="columnValueList(header.value)" v-model="filters[header.value]"></v-autocomplete>
          </v-col>
        </v-row>
      </template>

      <template v-slot:[`item.isactive`]="{ item }">
        <span v-if="item.isactive">
          <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    // extraBreadcrumbItems: [
    //   { text: "Allot Leaves", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    overlay: false,
    errorMsg: {
      castId: false,
    },
    menu: "",
    menu1: "",
    emenu: "",
    emenu1: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    filterArr: [],
    filters: {
      instructor: [],
      leaveacademicyear: [],
      leavetype: [],
      employeetype: [],
      servicetype: []
    },
    table_fields: {
      Employee: "instructor",
      "Leave Academic Year": "leaveacademicyear",
      "Leave Type": "leavetype",
      "Employee Type": "employeetype",
      "From Date": "fromDate",
      "To Date": "toDate",
      "No Of Leaves": "numberOfDays",
    },
    headers: [
      {
        text: "Employee",
        align: "left",
        sortable: false,
        value: "instructor",
      },
      {
        text: "Leave Academic Year",
        align: "left",
        sortable: false,
        value: "leaveacademicyear",
      },
      {
        text: "Leave Type",
        align: "left",
        sortable: false,
        value: "leavetype",
      },
      {
        text: "Employee Type",
        align: "left",
        sortable: false,
        value: "employeetype",
      },
      {
        text: "Employee Category",
        align: "left",
        sortable: false,
        value: "servicetype",
      },
      {
        text: "From Date",
        align: "left",
        sortable: false,
        value: "fromDate",
      },
      {
        text: "To Date",
        align: "left",
        sortable: false,
        value: "toDate",
      },
      {
        text: "No Of Leaves",
        align: "left",
        sortable: false,
        value: "numberOfDays",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    allot_leaves_list: [],
    employee_list: [],
    leave_type_list: [],
    leave_academic_year_list: [],
    employee_type_list: [],
    service_type_list:[],
    editedIndex: -1,
    serviceType:"",
    editedItem: {
      allotLeavesId: "",
      leaveTypeId: "",
      leaveAcademicYearId: "",
      leaveType: "",
      leaveAcademicYear: "",
      isActive: true,
      employeeType: "",
      employee: null,
      fromDate: "",
      toDate: "",
      from: "",
      to: "",
      numberOfDays: "",
    },
    defaultItem: {
      /*
        allotLeavesId: '',
        leaveAcademicYearId: '', 
        leaveTypeId:'' ,  */
      leaveAcademicYear: null,
      leaveType: null,
      isActive: true,
      employeeType: null,
      fromDate: "",
      toDate: "",
      numberOfDays: "",
      employee: null,
    },
    selected_all_teacher:false,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Allot Leaves" : "Edit Allot Leaves";
    },
    bookList1() {
      return this.allot_leaves_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    putnull() {
      this.editedItem.from = "";
      this.editedItem.to = "";
      this.editedItem.numberOfDays = "";
      this.editedItem.employeeType = "";
      this.serviceType = ""
    },
     toggle_teacher() {
      this.$nextTick().then(() => {
        if (this.selected_all_teacher) {
          this.editedItem.employee = [];
          for (var x in this.employee_list) {
            this.editedItem.employee.push(this.employee_list[x].id);
          }
         
        } else {
          this.editedItem.employee = [];
        }
      });
    },
    columnValueList(val) {
      return this.allot_leaves_list.map((d) => d[val]);
    },
    getDataFromLeaveMaster() {
      //window.alert(JSON.stringify(this.editedItem.employeeType))
      if (this.editedItem.leaveType != "") {
        const data = {
          leaveType: this.editedItem.leaveType,
          ay: this.editedItem.leaveAcademicYear,
          empType: this.editedItem.employeeType.id,
          serviceType: this.serviceType ? this.serviceType.id : null,
        };
        axios
          .post("/LeaveManagement/getDataFromLeaveMaster", data)
          .then((res) => {
            if (res.data.flag == "Yes") {
              this.editedItem.from = res.data.fromDate;
              this.editedItem.to = res.data.toDate;
              this.editedItem.numberOfDays = res.data.numberOfDays;
            } else if (res.data.flag == "No") {
              this.showSnackbar("red", res.data.snackbar);
              this.editedItem.from = "";
              this.editedItem.to = "";
              this.editedItem.numberOfDays = "";
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
      }
    },
    getEmployeeList(item) {
      var params={"employee_type_id":item.employeeType.id, "service_type_id":this.serviceType ? this.serviceType.id : null}
      axios
        .post("/LeaveManagement/getEmployeeListFromEmployeeType", params)
        .then((res) => {
          if(res.data.msg=="200"){
          this.employee_list = res.data.inst_list;
          this.getDataFromLeaveMaster();
          }
          else{
            this.showSnackbar("#b71c1c", res.data.msg);
          }
         
        })
       
    },
    initializeErrorMsgFalse() {
      this.errorMsg.castId = false;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/LeaveManagement/getAllotLeaves")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.leave_type_list = res.data.leave_type_list;
              this.leave_academic_year_list = res.data.leave_academic_year_list;
              this.employee_type_list = res.data.employee_type_list;
              //this.employee_list = res.data.employee_list;
              this.allot_leaves_list = res.data.allot_leaves_list;
              this.editedItem.leaveAcademicYear = res.data.clay;
              this.service_type_list = res.data.service_type_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          //window.console.log("Errro------>"+error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      //window.alert(JSON.stringify(item))
      this.editedIndex = this.allot_leaves_list.indexOf(item);
      this.dialog = true;
      this.editedItem.allotLeavesId = item.id;
      this.editedItem.leaveAcademicYear = item.leaveAcademicYear;
      this.editedItem.leaveAcademicYearId = item.leaveacademicyearid;
      this.editedItem.fromDate = item.fromDate;
      this.editedItem.toDate = item.toDate;
      this.editedItem.from = item.from;
      this.editedItem.to = item.to;
      this.editedItem.numberOfDays = item.numberOfDays.toString();
      this.editedItem.leaveType = item.leavetype;
      this.editedItem.leaveTypeId = item.leavetypeid;
      this.editedItem.employee = item.instructor;
      //window.alert(JSON.stringify(this.editedItem))
    },

    // deleteItem (item) {
    //   const index = this.language_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          if (
            this.editedItem.numberOfDays == null ||
            this.editedItem.numberOfDays == "" ||
            this.editedItem.numberOfDays == "null"
          ) {
            this.showSnackbar("#b71c1c", "Please Select Number Of Days");
          } else if (
            this.editedItem.from == null ||
            this.editedItem.from == "" ||
            this.editedItem.from == "null"
          ) {
            this.showSnackbar("#b71c1c", "Please Select From Date");
          } else if (
            this.editedItem.to == null ||
            this.editedItem.to == "" ||
            this.editedItem.to == "null"
          ) {
            this.showSnackbar("#b71c1c", "Please Select To Date");
          } else {
            const formData = {
              allotLeavesId: this.editedItem.allotLeavesId,
              leaveacademicYear: this.editedItem.academicYearId,
              from: this.editedItem.from,
              to: this.editedItem.to,
              numberOfDays: this.editedItem.numberOfDays,
              isActive: this.editedItem.isActive,
              leaveType: this.editedItem.leaveTypeId,
            };
            this.overlay = true;
            axios
              .post("/LeaveManagement/editAllotLeaves", formData)
              .then((res) => {
                if (res.data.status.code == "SUCCESS") {
                  this.showSnackbar(
                    "#4caf50",
                    "Allot Leaves Updated Successfully..."
                  ); // show snackbar on success
                  this.onLoad();
                  this.overlay = false;
                } else if (res.data.status.code == "NA") {
                  this.showSnackbar("#b71c1c", "Leaves Already Alloted.."); // show snackbar on error
                }
              })
              .catch((error) => {
                this.showSnackbar("#b71c1c", "Something Went Wrong..");
                //window.console.log(error);
              });
            this.close();
          }
        }
      } else {
        if (
          this.editedItem.leaveAcademicYear == null ||
          this.editedItem.leaveAcademicYear == "" ||
          this.editedItem.leaveAcademicYear == "null"
        ) {
          this.showSnackbar("#b71c1c", "Please Select Academic Year");
        } else if (
          this.editedItem.leaveType == null ||
          this.editedItem.leaveType == "" ||
          this.editedItem.leaveType == "null"
        ) {
          this.showSnackbar("#b71c1c", "Please Select Leave Type");
        } else if (
          this.editedItem.employee == "" ||
          this.editedItem.employee == "null"
        ) {
          this.showSnackbar("#b71c1c", "Please Select Employee");
        } else if (
          this.editedItem.numberOfDays == null ||
          this.editedItem.numberOfDays == "" ||
          this.editedItem.numberOfDays == "null"
        ) {
          this.showSnackbar("#b71c1c", "Please Select Number Of Days");
        } else if (
          this.editedItem.from == null ||
          this.editedItem.from == "" ||
          this.editedItem.from == "null"
        ) {
          this.showSnackbar("#b71c1c", "Please Select From Date");
        } else if (
          this.editedItem.to == null ||
          this.editedItem.to == "" ||
          this.editedItem.to == "null"
        ) {
          this.showSnackbar("#b71c1c", "Please Select To Date");
        } else {
          const formData = {
            leaveAcademicYear: this.editedItem.leaveAcademicYear,
            fromDate: this.editedItem.from,
            toDate: this.editedItem.to,
            numberOfDays: this.editedItem.numberOfDays,
            isActive: this.editedItem.isActive,
            leaveType: this.editedItem.leaveType,
            employee: this.editedItem.employee,
            employeeType: this.editedItem.employeeType.id,
          };
          this.overlay = true;
          axios
            .post("/LeaveManagement/saveAllotLeaves", formData)
            .then((res) => {
              //window.alert(JSON.stringify(res.data))
              if (res.data.status.code == "SUCCESS") {
                this.overlay = false;
                this.showSnackbar(
                  "#4caf50",
                  "Leaves Alloted to Employee Successfully..."
                );
                //this.showSnackbar("#b71c1c", res.data.duplicateSize +" Duplicates Skipped");
                this.onLoad();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Leave Type Already Alloted to this Employee"
                );
              }
            })
            .catch((error) => {
              window.console.log(error);
            })
            .finally(() => {
              this.onLoad();
              this.overlay = false;
            });

          this.close();
        }
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.allotLeavesId) {
        return true;
      } else {
        if (!this.editedItem.allotLeavesId) {
          this.errorMsg.allotLeavesId = true;
        }
        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
input[type="date"] {
  width: 100%;
  display: inline-block;
  padding: 0.4rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  /* padding-top: none !important;
  margin-top: none !important; */
}

.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}

.v-icon-size {
  font-size: 20px;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}

.edit-avatar:hover {
  background-color: #b0bec5;
}

.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}

.edit-v-icon:hover {
  color: white;
}

.tc-title {
  background-image: linear-gradient(-90deg, #fff, blue);
  color: #fff;
  border-radius: 3px;
}

.table-head {
  background: #0f2027;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #2c5364,
      #203a43,
      #0f2027);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: white !important;
}

.textcolor {
  color: darkblue;
  font-weight: bold;
}

td,
th {
  border: 1px solid #ccc;
}

tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
}

td {
  font-weight: bold;
}

td {
  margin: 1rem !important;
  padding: 1rem !important;
}

@media (min-width: 320px) {

  td,
  th {
    display: table-cell !important;
  }

  td+td,
  th+th {
    width: auto;
  }
}

sub-row {
  border: 2px solid #424093;
  margin: 1rem;
  border-radius: 5px;
}

i {
  font-size: 20px !important;
}

.v-card__title {
  border: 1px solid #80808040;
  font-weight: bold;
  background-color: #424093;
  color: white;
  text-align: center;
  /* margin-top: 1.5rem; */
}

.card-border {
  border: 2px solid darkblue;
  border-radius: 10px;
  /* padding: 5px; */
  /* margin: 1rem !important; */
  width: auto;
}

.tx-bold {
  font-weight: bold;
  font-size: 14px;
  color: black;
}

i {
  font-size: 26px;
  cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #424093 !important;
  color: white !important;
  margin-top: 2.35rem;
  border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {}

.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}

.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}

v-simple-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: auto;
  border: 1px solid #ddd;
}

th {
  color: white;
  font-weight: bold;
  text-align: center !important;
}

td,
th {
  padding: 6px;
  border: 1px solid #ccc;
  text-align: center;
}

@media all and (max-width: 900px) {
  .padding-bot {
    padding: 8px;
  }
}

@media all and (min-width: 1000px) {
  .padding-metting {
    padding-right: 22px;
  }
}

@media (min-width: 320px) and (max-width: 350px) {
  .padding-bot {
    font-size: 11.6px;
  }
}

@media (min-width: 1000px) and (max-width: 1050px) {
  .padding-bot {
    font-size: 9.6px;
  }
}

.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
</style>